import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TextareaControl } from '../../../controls/setup-wizard/textarea-control/textarea-control';

@Component({
	selector: 'app-textarea-field',
	standalone: true,
	imports: [TextareaControl],
	templateUrl: './textarea-field.html',
})
export class TextareaField {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	minLength = input<number | null>(null);
	rows = input<number>(4);
	formGroup = input.required<FormGroup>();
}
